import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class ReportReviewQueryService {

    public GET_REPORT_FORM: any;


    constructor(public apollo: Apollo) {

        /**Check reportId exist */
        /**Get matched id details */

        this.GET_REPORT_FORM = gql`
                query getReportForm($insReportId:String!){
                    allReportReviewDetails(condition:{insReportId:$insReportId,approve:"yes"},orderBy:REVIEW_ID_ASC) {

                                    nodes {
                                      approveDatetime
                                        reviewId
                                        orderId
                                        insReportId
                                        categoryId
                                        subCategoryId
                                        categoryName
                                        subCategoryName
                                        description
                                        solution
                                        totalCost
                                        nodeId
                                        imagePath
                                        solCategory
                                        solSubCategory
                                        itemNumWc
                                        approve
                                        reportSolutionMastersByReviewId {
                                            nodes {
                                                acceptStatus
                                            }

                                        }
                                }

                            }
                        }
                `;
    }


    /**Check reportId exist & get current id details */

    doLogin(insReportId: string) {
        return this.apollo.watchQuery({
            query: this.GET_REPORT_FORM,
            variables:
            {
                'insReportId': insReportId,
            },
            fetchPolicy: 'network-only'

        });
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/gql-query-mutation/report-review.service.ts